__turbopack_context__.v({
  "bannerContainer": "staticChannelCardStrip-module-scss-module__d4qxJW__bannerContainer",
  "borderBackground": "staticChannelCardStrip-module-scss-module__d4qxJW__borderBackground",
  "colorBorder": "staticChannelCardStrip-module-scss-module__d4qxJW__colorBorder",
  "contentContainer": "staticChannelCardStrip-module-scss-module__d4qxJW__contentContainer",
  "disableShadow": "staticChannelCardStrip-module-scss-module__d4qxJW__disableShadow",
  "imageContainer": "staticChannelCardStrip-module-scss-module__d4qxJW__imageContainer",
  "listenLiveText": "staticChannelCardStrip-module-scss-module__d4qxJW__listenLiveText",
  "playIcon": "staticChannelCardStrip-module-scss-module__d4qxJW__playIcon",
  "radioImage": "staticChannelCardStrip-module-scss-module__d4qxJW__radioImage",
  "wrapper": "staticChannelCardStrip-module-scss-module__d4qxJW__wrapper",
});
